import React from "react";
import useStyles from './style';
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

export default function ModalDeletePhotos(props) {

    const classes = useStyles()
    const deletePhotos = () => {
        props.setOpenModalDeletePhotos(false)
        props.setSpinnerValue(1)
        fetch(process.env.REACT_APP_API_URL + "/api/photos/deletePhoto", {
            method: "DELETE",
            headers: {
                "Content-type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                filename: props.actualDeletePhotos
            })
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        })
            .then((response) => {
                props.setSuccess("Photos suprimée")
                props.getTheme()
                props.setSpinnerValue(0)
            })
            .catch(function (error) {
                props.setError("Erreur")
                props.setSpinnerValue(0)
            });
    }


    const body = (
        <div className={classes.paper}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography component="h1" variant="h6" color="inherit" className={classes.title}>
                        Voulez-vous vraiment supprimer cette photo ?
                    </Typography>
                </Grid>

                <Grid item xs={6}>
                    <Button variant="contained" color={"primary"} onClick={deletePhotos}>
                        Valider
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button variant="contained" onClick={() => props.setOpenModalDeletePhotos(false)}>
                        Retour
                    </Button>
                </Grid>

            </Grid>
        </div>
    );

    return (
        <Modal
            open={props.openModalDeletePhotos}
            onClose={() => props.setOpenModalDeletePhotos(false)}
        >
            {body}
        </Modal>
    );

}